


























import { Component,	Vue } from 'vue-property-decorator';

import { bus } from '@/main'
import GlobalMixins from '@/mixins'
import { Languages } from '@/enums'

import InfoButton from '@/components/InfoButton.vue'

@Component({
	components: {
		InfoButton
	}
})
export default class SelectAge extends GlobalMixins {
	recordAge(age: '<23' | '23+') {
		this.$store.dispatch('setUserAge', age)
		this.$router.push({ name: this.language === Languages.NL ? 'select-branch' : 'select-branch-'+this.language })
	}

	mounted() {
		bus.$emit('setNextButton', false)
	}
}
